export default __webpack_public_path__ + "static/media/35.b25cb96c.png";